import React, { useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

export default function DeleteButton({ name, onDelete, hide }) {

  const handleDeleteClick = () => {
    Swal.fire({
      title: `<h4>Are you sure to delete "${name}"?</h4>`,
      text: "This will permanently delete all related data and cannot be recovered.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      customClass: {
        title: "swal-custom-title",
        icon: "swal-custom-icon",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(); 
      }
    });
  };

  return (
    <Link
      className="dropdown-item text-danger"
      to="#"
      onClick={(e) => {
        e.preventDefault(); // Prevent page reload
        handleDeleteClick();
      }}
    >
      <img
        src="/assets/images/kidskart/icon/trash-bin.png"
        alt="Delete"
        className="me-2"
      />
      {hide ? "" : "Delete"}
    </Link>
  );
}
